import script from "./FollowStatsCards.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowStatsCards.vue?vue&type=script&setup=true&lang=js"

import "./FollowStatsCards.vue?vue&type=style&index=0&id=4283b2b7&scoped=true&lang=css"
import "./FollowStatsCards.vue?vue&type=style&index=1&id=4283b2b7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4283b2b7"]])

export default __exports__